module.exports = __webpack_public_path__ + "a0247997c0da76650238d953200caa24.svg";